"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const FormWrapper_1 = require("./FormWrapper");
const typography_1 = require("../../shared/typography");
const form_1 = require("../../molecules/form/form");
const useForm_1 = __importDefault(require("../../shared/hooks/useForm"));
const form_2 = require("../../atoms/form");
const buttons_1 = require("../../atoms/buttons");
const react_i18next_1 = require("react-i18next");
const ResetConfirm = ({ translations, onSubmit, disabled }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.H1, { children: translations.emailSent }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.instruction }, void 0), (0, jsx_runtime_1.jsx)(form_1.Form, { variant: "vertical", onSubmit: onSubmit, children: (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", disabled: disabled, type: "submit", children: translations.buttonSubmit }, void 0) }, void 0)] }, void 0));
const ResetForm = ({ translations, onSubmit, onLinkClick, disabled, error }) => {
    const [values, setValues] = (0, useForm_1.default)({ email: "" });
    const onFormSubmit = (e) => {
        e.preventDefault();
        onSubmit(values);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.H1, { children: translations.title }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.subTitle }, void 0), (0, jsx_runtime_1.jsxs)(form_1.Form, { variant: "vertical", onSubmit: onFormSubmit, noValidate: true, children: [(0, jsx_runtime_1.jsx)("label", { children: translations.emailLabel }, void 0), (0, jsx_runtime_1.jsx)(form_2.Input, { name: "email", onChange: setValues, placeholder: translations.emailPlaceholder, type: "email", required: false }, void 0), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: error && (0, jsx_runtime_1.jsx)(typography_1.P, { children: error }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", disabled: disabled, type: "submit", children: translations.buttonLabel }, void 0), (0, jsx_runtime_1.jsx)("a", { role: "button", onClick: onLinkClick, children: translations.backToLoginLink }, void 0)] }, void 0)] }, void 0));
};
const ResetPasswordForm = ({ onSubmit, disabled, onLinkClick, error, isConfirm, showLogo, logoSVG }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(FormWrapper_1.FormWrapper, { logoText: t("resetPassword.logoText"), showLogo: showLogo, logoSVG: logoSVG, children: (0, jsx_runtime_1.jsx)(Content, { children: isConfirm ? ((0, jsx_runtime_1.jsx)(ResetConfirm, { translations: t("resetPassword.confirm", { returnObjects: true }), onSubmit: onLinkClick, disabled: disabled }, void 0)) : ((0, jsx_runtime_1.jsx)(ResetForm, { onSubmit: onSubmit, translations: t("resetPassword", { returnObjects: true }), onLinkClick: onLinkClick, disabled: Boolean(disabled), error: error }, void 0)) }, void 0) }, void 0));
};
exports.ResetPasswordForm = ResetPasswordForm;
const Content = styled_components_1.default.div `
  min-width: 296px;
  width: 50%;

  & > h1 {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > p {
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }

  & form > p {
    color: ${({ theme }) => theme.colors.pinkBase};
    font-size: 0.875rem;
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }
`;
//# sourceMappingURL=ResetPassword.js.map